import { DataTableColumnSort } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import { useGooglePlacesDoorBaseTableCols } from '../../GooglePlaceBase/GooglePlaceDoorBaseTable/GooglePlaceBaseDoorTableColumns'
import { CONVENIENCE_DOORS_COLUMNS } from '../ConvenienceDoorsColumnsInfo'

export const useConvenienceDoorsTableCols = ({
  sorting,
  inCampaigns,
}: {
  sorting?: DataTableColumnSort[]
  inCampaigns?: boolean
}) => {
  const commonColumns = useGooglePlacesDoorBaseTableCols({
    sorting,
    inCampaigns,
    accesor: 'cstore',
    tableColumns: CONVENIENCE_DOORS_COLUMNS,
    linkPrefix: 'convenience/door',
  })
  return commonColumns
}
